import React, { useEffect, useState, useContext, useCallback } from "react";
import { AppContent, AppHeader, BackToTop, WhatsApp } from "../components/index";
import { Container, Row, Col } from "reactstrap";
import { Link, useLocation } from "react-router-dom";
import sidebarContext from "../context/sidebar/sidebarContext";
import { Softorithm_White_Logo } from "../images";

const DefaultLayout = () => {
  const [windowWidth, setWindowWidth] = useState(window.innerWidth);
  const location = useLocation();
  const [newsletterEmail, setNewsletterEmail] = useState("");

  // to use sidebar using context
  const sidebarcontext = useContext(sidebarContext);
  /// de strusture
  const { sidebarstate } = sidebarcontext;

  const handleResize = useCallback(() => {
    setWindowWidth(window.innerWidth);
  }, []);

  useEffect(() => {
    window.addEventListener("resize", handleResize);

    return () => {
      window.removeEventListener("resize", handleResize);
    };
  }, [handleResize]);

  const [showFooter, setShowFooter] = useState(true);
  useEffect(() => {
    // Footer is now shown on all pages including contact-us
    setShowFooter(true);
  }, [location.pathname]);

  const handleNewsletterSubmit = (e) => {
    e.preventDefault();
    // Handle newsletter subscription
    console.log("Newsletter subscription:", newsletterEmail);
    setNewsletterEmail("");
  };

  return (
    <>
      <div
        className={`static_page  ${windowWidth < 1024 ? `small_view ` : " "} ${
          sidebarstate ? "small_view_ham" : ""
        }`}
      >
        <AppHeader />
        <AppContent />
        {showFooter && (
          <>
            {/* OLD FOOTER - COMMENTED OUT */}
            {/* <footer className="py-4 mt-4 bg-dark position-relative services_footer">
              <div className="bg-overlay bg-overlay-pattern opacity-50"></div>
              <Container>
                <Row className="mb-3">
                  <Col className="text-center">
                    <a
                      href="https://www.SmarterASP.NET/index?r=softorithm"
                      target="_blank"
                      rel="noopener noreferrer"
                    >
                      <img
                        src="https://www.SmarterASP.NET/affiliate/728X90.gif"
                        border="0"
                        alt="SmarterASP.NET Hosting"
                      />
                    </a>
                  </Col>
                </Row>
                <Row className="align-items-center">
                  <Col lg={8} className="text-center text-lg-start">
                    <div className="mb-3 mb-lg-0">
                      <h4 className="text-white mb-0 fw-semibold">
                        Power Up Your Business: Get Started Today
                      </h4>
                    </div>
                  </Col>
                  <Col lg={4} className="text-center text-lg-end">
                    <div className="connect_container">
                      <Link
                        to="/contact-us"
                        target="_blank"
                        className="btn convert_btn"
                      >
                        Connect With Us
                      </Link>
                      <ul className="social_icons mt-1">
                        <li>
                          <Link
                            to="instagram.com/softorithm"
                            className="icon_link"
                          >
                            <i className="ri-instagram-line instagram_icon"></i>
                          </Link>
                        </li>
                        <li>
                          <Link
                            to="facebook.com/softorithm"
                            className="icon_link"
                          >
                            <i className="ri-facebook-box-fill facebook_icon"></i>
                          </Link>
                        </li>
                        <li>
                          <Link
                            to="https://www.youtube.com/@softorithm"
                            className="icon_link"
                          >
                            <i className="ri-youtube-line youtube_icon"></i>
                          </Link>
                        </li>
                        <li>
                          <Link
                            to="https://www.tiktok.com/@softorithm"
                            className="icon_link"
                          >
                            <i className="ri-tiktok-fill tiktok_icon"></i>
                          </Link>
                        </li>
                      </ul>
                    </div>
                  </Col>
                </Row>
              </Container>
            </footer> */}

            {/* NEW FOOTER */}
            <footer className="py-5 mt-4 bg-dark position-relative" style={{ backgroundColor: '#181818' }}>
              <Container>
                <Row className="mb-4 justify-content-center">
                  {/* Navigation Links */}
                  <Col lg={3} md={6} sm={6} xs={6} className="mb-4 mb-lg-0 text-center text-lg-start">
                    <h6 className="text-white mb-3 fw-semibold">Company</h6>
                    <ul className="list-unstyled">
                      <li className="mb-2">
                        <Link to="/about" className="text-white-50 text-decoration-none">
                          About
                        </Link>
                      </li>
                      <li className="mb-2">
                        <Link to="/blogs" className="text-white-50 text-decoration-none">
                          Blog
                        </Link>
                      </li>
                      <li className="mb-2">
                        <Link to="/contact-us" className="text-white-50 text-decoration-none">
                          Contact
                        </Link>
                      </li>
                      <li className="mb-2">
                        <Link to="/guest-post" className="text-white-50 text-decoration-none">
                          Guest Post
                        </Link>
                      </li>
                    </ul>
                  </Col>

                  <Col lg={3} md={6} sm={6} xs={6} className="mb-4 mb-lg-0 text-center text-lg-start">
                    <h6 className="text-white mb-3 fw-semibold">Who we help</h6>
                    <ul className="list-unstyled">
                      <li className="mb-2">
                        <Link to="#" className="text-white-50 text-decoration-none">
                          Manufactures
                        </Link>
                      </li>
                      <li className="mb-2">
                        <Link to="#" className="text-white-50 text-decoration-none">
                          Wholesalers
                        </Link>
                      </li>
                      <li className="mb-2">
                        <Link to="#" className="text-white-50 text-decoration-none">
                          Distributors
                        </Link>
                      </li>
                      <li className="mb-2">
                        <Link to="#" className="text-white-50 text-decoration-none">
                          Retailers
                        </Link>
                      </li>
                      <li className="mb-2">
                        <Link to="#" className="text-white-50 text-decoration-none">
                          Restaurants
                        </Link>
                      </li>
                      <li className="mb-2">
                        <Link to="#" className="text-white-50 text-decoration-none">
                          Super Marts
                        </Link>
                      </li>
                    </ul>
                  </Col>

                  <Col lg={3} md={6}  sm={6} xs={6} className="mb-4 mb-lg-0 text-center text-lg-start">
                    <h6 className="text-white mb-3 fw-semibold">What we do</h6>
                    <ul className="list-unstyled">
                      <li className="mb-2">
                        <Link to="/services/erp-business-software" className="text-white-50 text-decoration-none">
                          ERP Software
                        </Link>
                      </li>
                      <li className="mb-2">
                        <Link to="/services/web-design" className="text-white-50 text-decoration-none">
                          Web Design
                        </Link>
                      </li>
                      <li className="mb-2">
                        <Link to="/services/web-development" className="text-white-50 text-decoration-none">
                          Web Development
                        </Link>
                      </li>
                      <li className="mb-2">
                        <Link to="/services/digital-marketing" className="text-white-50 text-decoration-none">
                          Digital Marketing
                        </Link>
                      </li>
                      <li className="mb-2">
                        <Link to="/services/web-application-development" className="text-white-50 text-decoration-none">
                          Web App Dev
                        </Link>
                      </li>
                      <li className="mb-2">
                        <Link to="/services/video-editing-marketing" className="text-white-50 text-decoration-none">
                          Video Editing
                        </Link>
                      </li>
                    </ul>
                  </Col>

                  {/* Company Branding and Contact Information */}
                  <Col lg={3} md={6}  sm={6}  xs={6}  className="text-center text-lg-start">
                    <div className="mb-3 d-flex justify-content-center justify-content-lg-start">
                      <img 
                        src={Softorithm_White_Logo} 
                        alt="Company Logo" 
                        style={{ maxWidth: '200px', height: 'auto', marginBottom: '15px' }}
                      />
                    </div>
                    <div className="contact-info">
                      <div className="mb-2 d-flex align-items-center justify-content-center justify-content-lg-start">
                        <i className="ri-mail-line text-white me-2"></i>

                        <a href="mailto:support@softorithm.com" className="mail-to-email text-white text-decoration-none ">
                          support@softorithm.com
                        </a>
                      </div>
                      <div className="mb-3 d-flex align-items-center justify-content-center justify-content-lg-start">
                        <i className="ri-phone-line text-white me-2"></i>
                        <a href="tel:+923338469166" className="text-white text-decoration-none">
                          +92 333 8469166
                        </a>
                      </div>
                      <div className="social-icons d-flex gap-2 justify-content-center justify-content-lg-start">
                        <a href="https://youtube.com/@softorithm" target="_blank" rel="noopener noreferrer" className="text-white">
                          <i className="ri-youtube-fill" style={{ fontSize: '20px' }}></i>
                        </a>
                        <a href="https://facebook.com/softorithm" target="_blank" rel="noopener noreferrer" className="text-white">
                          <i className="ri-facebook-fill" style={{ fontSize: '20px' }}></i>
                        </a>
                        <a href="https://instagram.com/softorithm" target="_blank" rel="noopener noreferrer" className="text-white">
                          <i className="ri-instagram-line" style={{ fontSize: '20px' }}></i>
                        </a>
                        <a href="https://tiktok.com/@softorithm" target="_blank" rel="noopener noreferrer" className="text-white">
                          <i className="ri-tiktok-fill" style={{ fontSize: '20px' }}></i>
                        </a>
                        <a href="https://linkedin.com/company/softorithm" target="_blank" rel="noopener noreferrer" className="text-white">
                          <i className="ri-linkedin-fill" style={{ fontSize: '20px' }}></i>
                        </a>
                      </div>
                    </div>
                  </Col>
                </Row>

                {/* Newsletter Subscription Section */}
                <Row className="mb-4">
                  <Col lg={12} className="d-flex justify-content-center">
                    <div style={{ backgroundColor: '#00d4aa', padding: '20px', borderRadius: '4px', width: '100%', maxWidth: '80%' }}>
                      <div className="d-flex align-items-center justify-content-between flex-wrap" style={{ gap: '15px' }}>
                        <h5 className="text-white mb-0 fw-semibold">Get Latest Updates</h5>
                        <form onSubmit={handleNewsletterSubmit} className="d-flex flex-wrap gap-2" style={{ flex: '1 1 250px', maxWidth: '600px' }}>
                          <input
                            type="email"
                            className="form-control"
                            placeholder="Enter Your Email"
                            value={newsletterEmail}
                            onChange={(e) => setNewsletterEmail(e.target.value)}
                            required
                            style={{ flex: '1 1 150px', minWidth: '0' }}
                          />
                          <button
                            type="submit"
                            className="btn btn-primary"
                            style={{ backgroundColor: '#2ca876', color: 'white', border: 'none', padding: '8px 24px', whiteSpace: 'nowrap' }}
                          >
                            Subscribe
                          </button>
                        </form>
                      </div>
                    </div>
                  </Col>
                </Row>

                {/* Copyright and Policy Links */}
                <Row>
                  <Col lg={12}>
                    <div className="d-flex flex-wrap align-items-center justify-content-center gap-3 py-3 border-top border-secondary">
                      <span className="text-white-50">
                        © Copyright 2026 by Softorithm
                      </span>
                      <Link 
                        to="#" 
                        className="text-white-50 text-decoration-none"
                      >
                        Privacy Policy
                      </Link>
                      <Link 
                        to="#" 
                        className="text-white-50 text-decoration-none"
                      >
                        Sitemap
                      </Link>
                      <Link 
                        to="#" 
                        className="text-white-50 text-decoration-none"
                      >
                        Terms & Conditions
                      </Link>
                    </div>
                  </Col>
                </Row>
              </Container>
            </footer>
          </>
        )}
        <BackToTop />
        <WhatsApp
          brandName="SoftoRithm Technologies"
          status="Replies within 1 hour"
          messageText="How can we help?"
          number="923338469166"
        />
      </div>
    </>
  );
};

export default DefaultLayout;

